import { observer } from 'mobx-react-lite'

import { ScriptTitle } from '#components/MiniHeader/DocumentTitle'
import { Toolbar } from '#components/Toolbar'
import { useNavigation } from '#hooks'
import { useMst } from '#state'

import { HeaderTimestamp } from './HeaderTimestamp'
import { default as MiniHeader } from './MiniHeader'
import { ScriptSyncStatus } from './ScriptSyncStatus'

export const ScriptMiniHeader = observer(function ScriptMiniHeader() {
  const { user, location, currentScript } = useMst()
  const { navigateToFolder, navigateToRundown } = useNavigation()

  const handleCloseScript = () => {
    user.exitSplitLayout()
    const rundownId = location.getPathParam('rundownId')
    if (rundownId) {
      navigateToRundown(rundownId)
    } else {
      // or go back to the containing folder
      navigateToFolder(currentScript?.folderId)
    }
  }

  return (
    <Toolbar>
      <MiniHeader.LeftSection>
        {currentScript && <ScriptTitle script={currentScript} />}
        {currentScript && (
          <HeaderTimestamp
            userName={currentScript.lastModifier?.name}
            at={currentScript.contentsModifiedAt}
            createdAt={currentScript.createdAt}
          />
        )}
      </MiniHeader.LeftSection>
      <MiniHeader.RightSection>
        {currentScript && <ScriptSyncStatus script={currentScript} />}
        <Toolbar.Button icon="fa-xmark" onClick={handleCloseScript} />
      </MiniHeader.RightSection>
    </Toolbar>
  )
})
